import { render, staticRenderFns } from "./OverviewCustomer.vue?vue&type=template&id=01522448"
import script from "./OverviewCustomer.vue?vue&type=script&lang=js"
export * from "./OverviewCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports